import "../index.css";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  IconButton,
  LabelValue,
  Row,
  Tooltip,
  Typography,
} from "@/ui-kit";
import { PencilIcon } from "lucide-react";

type IProps = {
  expertise: string[];
  yearsOfExperience: number;
  onEdit?: () => void;
};

export const ExperienceCard = ({
  expertise,
  yearsOfExperience,
  onEdit,
}: IProps) => {
  const { t } = useTranslation();
  const labelWidth = "80px";

  return (
    <Card className="profile-card" variant="layer1">
      <CardContent>
        <Row gap={24} alignmentVertical="top">
          <div className="profile-card__details">
            <Row gap={12}>
              <Typography
                as="h3"
                weight="bold"
                variant="h3"
                color="text-primary"
                text={t("label.experience")}
              />

              {onEdit && (
                <div className="profile-card__actions">
                  <Tooltip content={t("action.edit")} placement="bottom-end">
                    <IconButton
                      size="sm"
                      variant="ghost"
                      color="layer2"
                      content={<PencilIcon />}
                      onClick={onEdit}
                      aria-label={t("action.edit")}
                    />
                  </Tooltip>
                </div>
              )}
            </Row>

            <div className="profile-card__sections">
              <div className="profile-card__section">
                <LabelValue
                  label={t("label.expertise")}
                  value={
                    expertise.length > 1 ? expertise.join(", ") : expertise[0]
                  }
                  labelWidth={labelWidth}
                />
                <LabelValue
                  label={t("label.experience")}
                  value={t("label.n_years", { count: yearsOfExperience })}
                  labelWidth={labelWidth}
                />
              </div>
            </div>
          </div>
        </Row>
      </CardContent>
    </Card>
  );
};
